import { SyntheticEvent, useState } from 'react'
import i18next from 'i18next'

type GanttParametersHandlersProps = {
  onCloseParameters: () => void
  onOpenParameters: () => void
}

export const useHandlers = ({
  onCloseParameters,
  onOpenParameters,
}: GanttParametersHandlersProps) => {
  const [openParameters, setOpenParameters] = useState<boolean>(false)
  const [currentTab, setCurrentTab] = useState(0)

  const handleOpenParameters = () => {
    setOpenParameters(true)
    setCurrentTab(0)
    onOpenParameters()
  }

  const handleCloseParameters = (isDirty: boolean) => {
    if (!isDirty || confirm(i18next.t('notifications.leave'))) {
      setOpenParameters(false)
      onCloseParameters()
    }
  }

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue)
  }

  return {
    state: {
      openParameters,
      currentTab,
    },
    handlers: {
      handleOpenParameters,
      handleCloseParameters,
      handleTabChange,
    },
  }
}
